export default __webpack_public_path__ + "static/media/1951.24aa5b5e.png";